module.exports = __webpack_public_path__ + "img/before4.bdfbae2f.jpg";